export default function calculateExpirationTime(currentTimestamp, expirationTimestamp) {
  const currentTime = currentTimestamp ? currentTimestamp : Math.floor(Date.now() / 1000); // Current time in Unix timestamp
  const millisecondsLeft = (expirationTimestamp - currentTime) * 1000; // Convert seconds to milliseconds
  const refreshTimeLeft = millisecondsLeft - 30000;

  if (millisecondsLeft < 0) {
    return 'EXPIRED';
  } else {
    return { expTimeLeft: millisecondsLeft, refreshTimeLeft };
  }
}
